import { Dynamo } from '..';
import { PrimaryRecordResourceCategory } from '../MedicalDataTypes';

export type GetAvatarResponse = {
    avatarUrl: string;
    name: string;
};

export type AvatarNotModified = {
    type: 'not-modified';
};

export type AvatarCleared = {
    type: 'cleared';
};

export type AvatarUpdated = {
    type: 'updated';
    tempAvatarFileId: string;
};

export type AvatarChange = AvatarNotModified | AvatarCleared | AvatarUpdated;

export type EntityReferences = {
    careTeam: number;
    collaborator: number;
    attachments: number;
    physician: string | null;
    comment: number;
    note: number;
} & Record<PrimaryRecordResourceCategory, number>;

export type Entitlement = Dynamo.UserProductEntitlements;

export type SubscriptionProductTypeIdentifiers = Dynamo.SubscriptionProductTypeIdentifiers;

export type OneTimePurchaseProductTypeIdentifiers = Dynamo.OneTimePurchaseProductTypeIdentifiers;

export type ProductTypeIdentifiers = Dynamo.ProductTypeIdentifiers;

export type ClientType = 'mobile' | 'mobile-dev' | 'local-web' | 'dev-web' | 'prod-web';
